import { motion } from "framer-motion";

const stats = [
  { value: "$100M+", label: "Transactions Advised" },
  { value: "End-to-End", label: "Advisory to Delivery" },
  { value: "Premium Markets", label: "Across Australia" },
  { value: "Selective", label: "By Invitation & Referral" },
];

export const CredentialStrip = () => {
  return (
    <section
      data-testid="credential-strip"
      style={{ background: "var(--bg-secondary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="stat-item"
              data-testid={`stat-${index}`}
            >
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
